import React from 'react'

import { useRemoteStrings } from '@acorns/web-utils'
import Lottie from 'lottie-react'

import contributionsAnimation from 'assets/lottie/contributions.lottie.json'
import useAnalyticsComponentViewed from 'hooks/useAnalyticsComponentViewed'
import {
  CONTRIBUTIONS_CONTENT,
  CONTRIBUTIONS_DETAILS,
  CONTRIBUTIONS_SECTION,
} from 'utils/testing/testIDs'

import { OPTIONS, SECTION_NAMES, baseAnalyticsOptions } from '../analytics'
import { ArticleButton } from '../shared/ArticleButton/ArticleButton'
import {
  Container,
  Content,
  DetailContainer,
  DetailHeader,
  InteractiveBackground,
  SectionIcon,
  Text,
  Title,
} from '../shared/SectionDetails'

const Contributions = ({
  beneficiaryId,
  custodianContribution,
  custodianNickname,
}: {
  beneficiaryId: string
  custodianContribution: string
  custodianNickname: string
}): React.ReactElement => {
  const { getRemoteString } = useRemoteStrings()
  const inViewContainerRef = useAnalyticsComponentViewed({
    action: 'Viewed',
    payload: {
      ...baseAnalyticsOptions,
      ...OPTIONS.CONTRIBUTIONS,
      beneficiaryId,
      event_description: 'Early Quarterly Recaps Contributions Section Viewed',
      object: 'Screen',
      object_name: 'earlyQuarterlyRecapsContributionsSection',
    },
  })

  return (
    <Container data-testid={CONTRIBUTIONS_SECTION} ref={inViewContainerRef}>
      <Content detailOnRight data-testid={CONTRIBUTIONS_CONTENT}>
        <ArticleButton
          beneficiaryId={beneficiaryId}
          section={SECTION_NAMES.CONTRIBUTIONS}
        />
        <InteractiveBackground>
          <Lottie animationData={contributionsAnimation} />
        </InteractiveBackground>
        <DetailContainer detailOnRight data-testid={CONTRIBUTIONS_DETAILS}>
          <SectionIcon sectionIndex={0} />
          <Title>
            {getRemoteString({
              key: 'early.recap.contributions.header.variable',
              variables: [custodianNickname],
            })}
          </Title>
          <DetailHeader isSmallFont={custodianContribution.length > 8}>
            {custodianContribution}
          </DetailHeader>
          <Text>
            {getRemoteString({
              key: 'early.recap.contributions.subheader',
            })}
          </Text>
        </DetailContainer>
      </Content>
    </Container>
  )
}

export { Contributions }
